import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'column',
        marginTop: 24,
    },
    reportTitle:{
        color: '#000000',
        letterSpacing: 4,
        fontSize: 20,
        textAlign: 'center',
        textTransform: 'uppercase',
    },
    subTitle:{
        color: '#000000',
        letterSpacing: 4,
        fontSize: 12,
        textAlign: 'center',
        textTransform: 'uppercase',
    }
  });


  const ReceiptTitle = ({title}) => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>{title}</Text>
        <Text style={styles.subTitle}>Transaction Receipt</Text>
    </View>
  );
  
  export default ReceiptTitle